import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import WorldPreview from "@/pages/WorldPreview";
import AdminPage from "@/pages/AdminPage";
import WorldEditor from "@/pages/WorldEditor";
import WorldsCategory from "@/pages/WorldsCategory";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/svet/:slug" element={<WorldPreview />} />
          <Route path="/svety/:kategorie" element={<WorldsCategory />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/svet/:id" element={<WorldEditor />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/obchodni-podminky" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
